const streamEmbedCSS = require('../client/streamEmbed.scss');

var displayTileHTML = function(readTimeTranslation, tile, readVal) {
    var tileTitle = tile.querySelector('.uf-tile-title');
    
    var span = document.createElement('span');
    span.setAttribute('class', 'read-time-tile');
    span.textContent = readTimeTranslation.replace('[time]', readVal);
    tileTitle.insertAdjacentElement('beforebegin', span);
  };
 
 var tileReadTime = function(readTimeTranslation) {
   var elemTiles = [...document.querySelectorAll('.uf-tile-wrapper')];
   var tagSearch = 'read-time';
   
   elemTiles.forEach((tile) => {
     if (tile.hasAttribute('data-tags') && !tile.querySelector('.read-time-tile')) {
       var dataTagsString = tile.dataset.tags.toLowerCase();
        var regex = new RegExp(tagSearch, 'gi');

        if (dataTagsString.match(regex)) {
          var array = dataTagsString.split(',');
          var readTag = array
            .filter((item) => {
              return item.match(regex);
            })
            .toString();

          var readVal = readTag
            .split('-')
            .filter((item) => {
              return !isNaN(item) ? item : '';
            })
            .toString();

          readVal !== '' ? displayTileHTML(readTimeTranslation, tile, readVal) : null;
     }
   }
 }
                     );
};
// loadTiles from handleTile partial
  var loadTiles = function(lang) {
    var tiles = [...document.querySelectorAll('.uf-tile-wrapper')];
     var readTime;
     lang === 'en' ? readTime = 'Read time: [time] min' : readTime = 'Temps de lire: [time] minutes'; 
    
    for(var i = 0; i < tiles.length; i++) {
      tileReadTime(readTime);
    }
  };

window._ufHubConfig.forEach(function(item) {
  var streamId = item.collection;
  document.addEventListener(
    `uberflip.initalEmbedTilesLoaded-${streamId}`,
    function(e) {
      // For English read time tags, set the parameter to 'en'
      // For French read time tags, set the parameter to 'fr'
      loadTiles('fr');
    }
  );
});


// WEBPACK FOOTER //
// ./entryPoints/streamEmbedFR.js